import { createSelector } from 'reselect';
import { actionTypes } from '../actions';

export const moduleName = 'signUp';

// Reducer (down)

const initialState = {
  pendingActivation: false,
  processing: false,
  error: '',
  saved: null,
};

export default function reducer(state = initialState, action) {
  const { error, type, payload } = action;

  switch (type) {
    case actionTypes.SIGN_UP_REGISTER_REQUEST: {
      const { params } = payload;

      return {
        ...state,
        processing: true,
        error: initialState.error,
        pendingActivation: false,
        saved: { ...params },
      };
    }

    case actionTypes.SIGN_UP_REGISTER_SUCCESS:
      return {
        ...state,
        processing: false,
        error: initialState.error,
        pendingActivation: true,
      };

    case actionTypes.SIGN_UP_REGISTER_FAILURE:
      return {
        ...state,
        processing: false,
        error: error || 'Unknown error',
        pendingActivation: false,
      };

    case actionTypes.SIGN_UP_RESET:
      return { ...initialState };

    default:
      return state;
  }
}

// Reducer (up)

// Selectors (down)

const stateSelector = (state) => state[moduleName];

export const selectSignUpPendingActivation = createSelector(
  stateSelector,
  (signUp) => signUp.pendingActivation,
);

export const selectSignUpProcessing = createSelector(
  stateSelector,
  (signUp) => signUp.processing,
);

export const selectSignUpError = createSelector(
  stateSelector,
  (signUp) => signUp.error,
);

export const selectSignUpSaved = createSelector(
  stateSelector,
  (signUp) => signUp.saved,
);

// Selectors (up)



// WEBPACK FOOTER //
// ./reducers/sign-up.js